import { render, staticRenderFns } from "./NorskOrdbankResult.vue?vue&type=template&id=f829a9f6&"
import script from "./NorskOrdbankResult.vue?vue&type=script&lang=js&"
export * from "./NorskOrdbankResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports